var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("div", [
    _c(
      "label",
      {
        staticClass: "col-4",
      },
      [
        _c(
          "span",
          {
            staticClass: "required",
          },
          [_c("translate", [_vm._v("Hostname")])],
          1
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.theHostname,
              expression: "theHostname",
            },
          ],
          attrs: {
            required: "",
            type: "text",
            name: "hostname",
            placeholder: "localhost",
          },
          domProps: {
            value: _vm.theHostname,
          },
          on: {
            input: function input($event) {
              if ($event.target.composing) {
                return
              }
              _vm.theHostname = $event.target.value
            },
          },
        }),
      ]
    ),
    _vm._v(" "),
    _c(
      "label",
      {
        staticClass: "col-2",
      },
      [
        _c(
          "span",
          {
            staticClass: "required",
          },
          [_c("translate", [_vm._v("Port")])],
          1
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.thePort,
              expression: "thePort",
            },
          ],
          attrs: {
            required: "",
            type: "text",
            name: "port",
            placeholder: "6379",
          },
          domProps: {
            value: _vm.thePort,
          },
          on: {
            input: function input($event) {
              if ($event.target.composing) {
                return
              }
              _vm.thePort = $event.target.value
            },
          },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }